<template>
  <v-card flat color="grey lighten-4" class="pa-2">
    <v-card-title class="py-0" v-if="title">
      <div class="blue-grey--text">
        {{ title }}
      </div>
    </v-card-title>
    <v-card-text class="py-0">
      <!-- default slot -->
      <slot />
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: false,
      default: ''
    }
  }
}
</script>
